import { ColDef } from '@ag-grid-community/core';

import { formatEmpty, formatNumber } from '@util/general/grid.util';

export const defaultColDef = {
  editable: false,
  resizable: true,
  sortable: true,
  filter: 'agTextColumnFilter',
  filterParams: {
    applyButton: true,
    resetButton: true,
  },
};

export const columnDefs: ColDef[] = [
  {
    headerName: 'Entry Date',
    field: 'entrydate',
    lockVisible: true,
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Modifiable',
    field: 'modifiable',
    lockVisible: true,
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'OrderType',
    field: 'ordertype',
    lockVisible: true,
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Order ID',
    field: 'ordershipid',
    lockVisible: true,
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Has Attachments',
    field: 'has_attachments',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Has Tracking Info',
    field: 'has_trackingno',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },

  {
    headerName: 'Customer',
    field: 'custid',
    lockVisible: true,
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'From Facility',
    field: 'fromfacility',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'To Facility',
    field: 'tofacility',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Status',
    field: 'orderstatusabbrev',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Reference',
    field: 'reference',
    editable: true,
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'PO',
    field: 'po',
    editable: true,
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Priority',
    field: 'priorityabbrev',
    editable: true,
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: { values: ['Hot', 'Normal', 'Back Order', 'ShipComplete', 'Drop Ship', 'Exception', 'No Notify', 'SameDayShip'] },
  },
  {
    headerName: 'Ship Type',
    field: 'shiptypeabbrev',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Carrier',
    field: 'carrier',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
    //todo: dropdown
  },
  {
    headerName: 'Ship To Code',
    field: 'shipto',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
    //todo: dropdown
  },
  {
    headerName: 'Ship To',
    field: 'shiptoname',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
  },
  {
    headerName: 'Qty Order',
    field: 'qtyorder',
    valueFormatter: (params) => formatNumber(params.value),
    cellStyle: { 'text-align': 'right' },
  },
  {
    headerName: 'Qty Rcvd',
    field: 'qtyrcvd',
    valueFormatter: (params) => formatNumber(params.value),
    cellStyle: { 'text-align': 'right' },
  },
  {
    headerName: 'Qty Commit',
    field: 'qtycommit',
    valueFormatter: (params) => formatNumber(params.value),
    cellStyle: { 'text-align': 'right' },
  },
  {
    headerName: 'Qty Pick',
    field: 'qtypick',
    valueFormatter: (params) => formatNumber(params.value),
    cellStyle: { 'text-align': 'right' },
  },
  {
    headerName: 'Qty Ship',
    field: 'qtyship',
    valueFormatter: (params) => formatNumber(params.value),
    cellStyle: { 'text-align': 'right' },
  },
  { headerName: 'Weight Entered', field: 'weightentered', cellStyle: { 'text-align': 'right' } },
  {
    headerName: 'Weight Order',
    field: 'weightorder',
    valueFormatter: (params) => formatNumber(params.value),
    cellStyle: { 'text-align': 'right' },
  },
  {
    headerName: 'Weight Commit',
    field: 'weightcommit',
    valueFormatter: (params) => formatNumber(params.value),
    cellStyle: { 'text-align': 'right' },
  },
  {
    headerName: 'Weight Ship',
    field: 'weightship',
    valueFormatter: (params) => formatNumber(params.value),
    cellStyle: { 'text-align': 'right' },
  },
  {
    headerName: 'Weight Pick',
    field: 'weightpick',
    valueFormatter: (params) => formatNumber(params.value),
    cellStyle: { 'text-align': 'right' },
  },
  {
    headerName: 'Weight Received',
    field: 'weightrcvd',
    valueFormatter: (params) => formatNumber(params.value),
    cellStyle: { 'text-align': 'right' },
  },
  {
    headerName: 'Appointment Date',
    field: 'apptdate',
    editable: true,
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Arrival Date',
    field: 'arrivaldate',
    editable: true,
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Ship Date',
    field: 'shipdate',
    editable: true,
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Received Date',
    field: 'rcvddate',
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'BOL',
    field: 'billoflading',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Hazardous Items',
    field: 'hazardous',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: (params) => {
      return {
        background: params.value === 'N' ? '#0f0' : '#f00',
        'text-align': 'center',
      };
    },
  },
  {
    headerName: 'Pro Number',
    field: 'prono',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'right' },
  },
  { headerName: 'RMA', field: 'rma', valueFormatter: (params) => formatEmpty(params.value), cellStyle: { 'text-align': 'center' } },
  {
    headerName: 'Status Update',
    field: 'statusupdate',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Service Class',
    field: 'deliveryservice',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
    //todo: dropdown
  },
  {
    headerName: 'Req Ship',
    field: 'requested_ship',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Ship No Later',
    field: 'ship_no_later',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Ship Not Before',
    field: 'ship_not_before',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Delivery Req',
    field: 'delivery_requested',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Do Not Deliver After',
    field: 'do_not_deliver_after',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Do Not Deliver Before',
    field: 'do_not_deliver_before',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  { headerName: 'Cancel After', field: 'cancel_after', valueFormatter: (params) => formatEmpty(params.value) },
  {
    headerName: 'Cancel Not Delivered By',
    field: 'cancel_if_not_delivered_by',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Ship To Contact',
    field: 'shiptocontact',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
  },
  {
    headerName: 'Ship To Addr1',
    field: 'shiptoaddr1',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
  },
  {
    headerName: 'Ship To Addr2',
    field: 'shiptoaddr2',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
  },
  {
    headerName: 'Ship To City',
    field: 'shiptocity',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
  },
  {
    headerName: 'Ship To State',
    field: 'shiptostate',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
    //todo: dropdown
  },
  {
    headerName: 'Ship To Zip',
    field: 'shiptopostalcode',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
  },
  {
    headerName: 'Ship To Country',
    field: 'shiptocountrycode',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
    //todo: dropdown
  },
  {
    headerName: 'Ship To Phone',
    field: 'shiptophone',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
  },
  {
    headerName: 'Ship To Fax',
    field: 'shiptofax',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
  },
  {
    headerName: 'Ship To Email',
    field: 'shiptoemail',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    editable: true,
  },
  {
    headerName: 'Date Shipped',
    field: 'dateshipped',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Shipping Cost',
    field: 'shippingcost',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Bill Freight To',
    field: 'consignee',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Attachment',
    field: 'attachment',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Instructions',
    field: 'comment1',
    cellEditor: 'agLargeTextCellEditor',
    cellEditorPopup: true,
    cellEditorParams: {
      maxLength: 2000,
      rows: 10,
      cols: 50,
    },
    minWidth: 250,
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'left' },
    editable: true,
  },
  {
    headerName: 'Trailer',
    field: 'trailer',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  { headerName: 'Seal', field: 'seal', valueFormatter: (params) => formatEmpty(params.value), cellStyle: { 'text-align': 'center' } },
  {
    headerName: 'Supplier',
    field: 'shipper',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'hdrpassthruchar01',
    field: 'hdrpassthruchar01',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar02',
    field: 'hdrpassthruchar02',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar03',
    field: 'hdrpassthruchar03',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar04',
    field: 'hdrpassthruchar04',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar05',
    field: 'hdrpassthruchar05',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar06',
    field: 'hdrpassthruchar06',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar07',
    field: 'hdrpassthruchar07',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar08',
    field: 'hdrpassthruchar08',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar09',
    field: 'hdrpassthruchar09',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar10',
    field: 'hdrpassthruchar10',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar11',
    field: 'hdrpassthruchar11',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar12',
    field: 'hdrpassthruchar12',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar13',
    field: 'hdrpassthruchar13',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar14',
    field: 'hdrpassthruchar14',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar15',
    field: 'hdrpassthruchar15',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar16',
    field: 'hdrpassthruchar16',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar17',
    field: 'hdrpassthruchar17',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar18',
    field: 'hdrpassthruchar18',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar19',
    field: 'hdrpassthruchar19',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar20',
    field: 'hdrpassthruchar20',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar21',
    field: 'hdrpassthruchar21',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar22',
    field: 'hdrpassthruchar22',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar23',
    field: 'hdrpassthruchar23',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar24',
    field: 'hdrpassthruchar24',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar25',
    field: 'hdrpassthruchar25',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar26',
    field: 'hdrpassthruchar26',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar27',
    field: 'hdrpassthruchar27',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar28',
    field: 'hdrpassthruchar28',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar29',
    field: 'hdrpassthruchar29',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar30',
    field: 'hdrpassthruchar30',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar31',
    field: 'hdrpassthruchar31',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar32',
    field: 'hdrpassthruchar32',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar33',
    field: 'hdrpassthruchar33',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar34',
    field: 'hdrpassthruchar34',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar35',
    field: 'hdrpassthruchar35',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar36',
    field: 'hdrpassthruchar36',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar37',
    field: 'hdrpassthruchar37',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar38',
    field: 'hdrpassthruchar38',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar39',
    field: 'hdrpassthruchar39',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar40',
    field: 'hdrpassthruchar40',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar41',
    field: 'hdrpassthruchar41',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar42',
    field: 'hdrpassthruchar42',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar43',
    field: 'hdrpassthruchar43',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar44',
    field: 'hdrpassthruchar44',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar45',
    field: 'hdrpassthruchar45',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar46',
    field: 'hdrpassthruchar46',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar47',
    field: 'hdrpassthruchar47',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar48',
    field: 'hdrpassthruchar48',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar49',
    field: 'hdrpassthruchar49',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar50',
    field: 'hdrpassthruchar50',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar51',
    field: 'hdrpassthruchar51',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar52',
    field: 'hdrpassthruchar52',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar53',
    field: 'hdrpassthruchar53',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar54',
    field: 'hdrpassthruchar54',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar55',
    field: 'hdrpassthruchar55',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar56',
    field: 'hdrpassthruchar56',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar57',
    field: 'hdrpassthruchar57',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar58',
    field: 'hdrpassthruchar58',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar59',
    field: 'hdrpassthruchar59',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthruchar60',
    field: 'hdrpassthruchar60',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrudate01',
    field: 'hdrpassthrudate01',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrudate02',
    field: 'hdrpassthrudate02',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrudate03',
    field: 'hdrpassthrudate03',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrudate04',
    field: 'hdrpassthrudate04',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrudoll01',
    field: 'hdrpassthrudoll01',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrudoll02',
    field: 'hdrpassthrudoll02',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrunum01',
    field: 'hdrpassthrunum01',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrunum02',
    field: 'hdrpassthrunum02',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrunum03',
    field: 'hdrpassthrunum03',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrunum04',
    field: 'hdrpassthrunum04',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrunum05',
    field: 'hdrpassthrunum05',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrunum06',
    field: 'hdrpassthrunum06',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrunum07',
    field: 'hdrpassthrunum07',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrunum08',
    field: 'hdrpassthrunum08',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrunum09',
    field: 'hdrpassthrunum09',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'hdrpassthrunum10',
    field: 'hdrpassthrunum10',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
  {
    headerName: 'Load_creation_passthru',
    field: 'load_creation_passthru',
    valueFormatter: (params) => formatEmpty(params.value),
    cellStyle: { 'text-align': 'center' },
    hide: true,
  },
];

export const defColumnPreferencesHdrPassThru_Y = [
  {
    colId: 'entrydate',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'modifiable', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'ordertype', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'ordershipid', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'has_attachments', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'has_trackingno', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },

  { colId: 'custid', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'fromfacility',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'tofacility', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'orderstatusabbrev',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'reference', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'po', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'priorityabbrev',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptypeabbrev',
    hide: false,
    aggFunc: null,
    width: 130,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'carrier', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'shipto', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'shiptoname', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtyorder', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtyrcvd', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtycommit', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtypick', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtyship', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightentered', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightorder', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightrcvd', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightcommit', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightpick', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightship', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'apptdate', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'shipdate', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'arrivaldate', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'billoflading',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'hazardous', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'prono', hide: false, aggFunc: null, width: 120, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'rma', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'statusupdate',
    hide: false,
    aggFunc: null,
    width: 130,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'deliveryservice',
    hide: false,
    aggFunc: null,
    width: 120,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'weightship', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'requested_ship',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'ship_no_later',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'ship_not_before',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'delivery_requested',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'do_not_deliver_after',
    hide: false,
    aggFunc: null,
    width: 180,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'do_not_deliver_before',
    hide: false,
    aggFunc: null,
    width: 180,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'cancel_after',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'cancel_if_not_delivered_by',
    hide: false,
    aggFunc: null,
    width: 180,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptocontact',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'shiptoaddr1', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'shiptoaddr2', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'shiptocity', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'shiptostate', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'shiptopostalcode',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptocountrycode',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'shiptophone', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'shiptofax', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'shiptoemail', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'dateshipped', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'shippingcost',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'consignee', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'attachment', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'instructions', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'trailer', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'seal', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'shipper', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'rcvddate', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'hdrpassthruchar01',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar02',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar03',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar04',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar05',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar06',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar07',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar08',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar09',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar10',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar11',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar12',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar13',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar14',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar15',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar16',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar17',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar18',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar19',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar20',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar21',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar22',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar23',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar24',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar25',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar26',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar27',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar28',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar29',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar30',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar31',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar32',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar33',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar34',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar35',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar36',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar37',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar38',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar39',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar40',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar41',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar42',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar43',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar44',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar45',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar46',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar47',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar48',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar49',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar50',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar51',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar52',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar53',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar54',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar55',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar56',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar57',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar58',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar59',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar60',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudate01',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudate02',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudate03',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudate04',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudoll01',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudoll02',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum01',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum02',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum03',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum04',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum05',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum06',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum07',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum08',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum09',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum10',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'load_creation_passthru',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
];

export const defColumnPreferences = [
  {
    colId: 'entrydate',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'modifiable',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'ordertype',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'ordershipid',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'has_attachments',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'has_trackingno',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'custid',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'fromfacility',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'tofacility',
    hide: false,
    aggFunc: null,
    width: 130,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'orderstatusabbrev',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'reference',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'po',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'priorityabbrev',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptypeabbrev',
    hide: false,
    aggFunc: null,
    width: 130,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'carrier',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shipto',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptoname',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'qtyorder',
    hide: false,
    aggFunc: null,
    width: 130,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'qtyrcvd',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'qtycommit',
    hide: false,
    aggFunc: null,
    width: 130,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'qtypick',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'qtyship',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'weightentered',
    hide: false,
    aggFunc: null,
    width: 130,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'weightorder',
    hide: false,
    aggFunc: null,
    width: 130,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'weightrcvd',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'weightcommit',
    hide: false,
    aggFunc: null,
    width: 130,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'weightpick',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'weightship',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'apptdate',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shipdate',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'arrivaldate',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'billoflading',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hazardous',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'prono',
    hide: false,
    aggFunc: null,
    width: 120,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'rma',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'statusupdate',
    hide: false,
    aggFunc: null,
    width: 130,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'deliveryservice',
    hide: false,
    aggFunc: null,
    width: 120,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'weightship',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'requested_ship',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'ship_no_later',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'ship_not_before',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'delivery_requested',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'do_not_deliver_after',
    hide: false,
    aggFunc: null,
    width: 180,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'do_not_deliver_before',
    hide: false,
    aggFunc: null,
    width: 180,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'cancel_after',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'cancel_if_not_delivered_by',
    hide: false,
    aggFunc: null,
    width: 180,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptocontact',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptoaddr1',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptoaddr2',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptocity',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptostate',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptopostalcode',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptocountrycode',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptophone',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptofax',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shiptoemail',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'dateshipped',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shippingcost',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'consignee',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'attachment',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'instructions', hide: false, aggFunc: null, width: 140, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'trailer',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'seal',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'shipper',
    hide: false,
    aggFunc: null,
    width: 110,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'rcvddate',
    hide: false,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar01',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar02',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar03',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar04',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar05',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar06',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar07',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar08',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar09',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar10',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar11',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar12',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar13',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar14',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar15',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar16',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar17',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar18',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar19',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar20',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar21',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar22',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar23',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar24',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar25',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar26',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar27',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar28',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar29',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar30',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar31',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar32',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar33',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar34',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar35',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar36',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar37',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar38',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar39',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar40',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar41',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar42',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar43',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar44',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar45',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar46',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar47',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar48',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar49',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar50',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar51',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar52',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar53',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar54',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar55',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar56',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar57',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar58',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar59',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthruchar60',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudate01',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudate02',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudate03',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudate04',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudoll01',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrudoll02',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum01',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum02',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum03',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum04',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum05',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum06',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum07',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum08',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum09',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'hdrpassthrunum10',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'load_creation_passthru',
    hide: true,
    aggFunc: null,
    width: 140,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
];
